import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { AppBar, Box, IconButton, Toolbar, Typography, useMediaQuery } from '@mui/material';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

// project import
import AppBarStyled from './AppBarStyled';
import { openDrawer } from 'store/features/menu/menuSlice';

import useConfig from 'hooks/useConfig';

// assets
// import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import HeaderContent from './HeaderContent/HeaderContent';

import { DRAWER_WIDTH, MINI_DRAWER_WIDTH, MenuOrientation, ThemeMode } from 'config';
import HamburgerIcon from 'assets/icons/hamburger';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';

// ==============================|| MAIN LAYOUT - HEADER ||============================== //

const Header = () => {
	const theme = useTheme();
	const dispatch = useDispatch();
	const downLG = useMediaQuery(theme.breakpoints.down('lg'));
	const { menuOrientation } = useConfig();

	const open = useSelector((state) => state.menu.drawerOpen);

	const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

	// const iconBackColor = 'grey.100';
	// const iconBackColorOpen = 'grey.200';

	// header content
	const headerContent = useMemo(() => <HeaderContent />, []);

	const iconBackColor = theme.palette.mode === ThemeMode.DARK ? 'background.default' : 'grey.100';

	// common header
	const mainHeader = (
		<Toolbar>
			{!isHorizontal ? (
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
					<IconButton
						disableRipple
						aria-label="open drawer"
						onClick={() => dispatch(openDrawer({ drawerOpen: !open }))}
						edge="start"
						color="secondary"
						variant="light"
						sx={{
							color: 'rgb(209, 213, 219)',
							bgcolor: 'transparent',
							ml: { xs: 0, lg: -2 },
							transform: open ? 'rotate(0deg)' : 'rotate(180deg)',
						}}
					>
						<HamburgerIcon />
					</IconButton>
					<IconButton
						component={Link}
						to="/comptroller"
						disableRipple
						sx={{
							color: 'rgb(209, 213, 219)',
							width: 'auto',
							height: 'auto',
							padding: '0 10px',
							display: { xs: 'none', md: 'flex' },
							alignItems: 'center',
							'&:hover': { color: '#ffffff' },
						}}
					>
						<Typography variant="body1">Comptroller</Typography>
					</IconButton>
				</Box>
			) : null}
			{headerContent}
		</Toolbar>
	);

	// app-bar params
	const appBar = {
		position: 'fixed',
		color: 'brandDark',
		elevation: 0,
		sx: {
			// bgcolor: 'brandDark.main',
			// color: 'brandDark.contrastText',
			// borderBottom: `1px solid ${theme.palette.border}`,
			// top: '4px',
			zIndex: 1000,
			width: isHorizontal ? '100%' : { xs: '100%', lg: open ? `calc(100% - ${DRAWER_WIDTH}px)` : `calc(100% - ${MINI_DRAWER_WIDTH}px)` },
		},
	};

	return (
		<>
			{!downLG ? (
				<AppBarStyled open={open} {...appBar}>
					{mainHeader}
				</AppBarStyled>
			) : (
				<AppBar {...appBar}>{mainHeader}</AppBar>
			)}
		</>
	);
};

Header.propTypes = {
	open: PropTypes.bool,
};

export default Header;
